import { OutfitSlotName } from 'types/outfit';

export const BOOTS = 'Boots';
export const HAT = 'Hat';
export const CLOTHING = 'Clothing';
export const GLOVES = 'Gloves';
export const WEAPON = 'Weapon';
export const COMPANION = 'Companion';
export const DESTINY = 'Destiny';
export const AFFILIATION = 'Affiliation';
export const HOME_COMFORT = 'HomeComfort';
export const SHIP = 'Ship';
export const SPOUSE = 'Spouse';
export const CLUB = 'Club';
export const TRANSPORTATION = 'Transportation';

export const OUTFIT_CATEGORIES: OutfitSlotName[] = [
  HAT,
  CLOTHING,
  GLOVES,
  WEAPON,
  BOOTS,
  COMPANION,
  DESTINY,
  AFFILIATION,
  TRANSPORTATION,
  HOME_COMFORT,
  SHIP,
  SPOUSE,
  CLUB,
];

// export const OUTFIT_CATEGORIES = {
  // Standard: [HAT, CLOTHING, GLOVES, WEAPON, BOOTS, COMPANION, DESTINY],
  // Expanded: [AFFILIATION, TRANSPORTATION, HOME_COMFORT, SHIP, SPOUSE, CLUB],
// };